import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=34f00e55&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=js&"
export * from "./Research.vue?vue&type=script&lang=js&"
import style0 from "./Research.vue?vue&type=style&index=0&id=34f00e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f00e55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f00e55')) {
      api.createRecord('34f00e55', component.options)
    } else {
      api.reload('34f00e55', component.options)
    }
    module.hot.accept("./Research.vue?vue&type=template&id=34f00e55&scoped=true&", function () {
      api.rerender('34f00e55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research.vue"
export default component.exports